<template>
  <div class="corporation_edit">
    <div
      v-for="headerTitle in headerTitles"
      :key="headerTitle.value"
      class="title_header"
      :style="{backgroundColor: headerTitle.color}"
    >
      <div
        class="title_header_value vertical_align_div"
        @click="pageLink(headerTitle.path)"
      >
        <span class="header_router">
          {{ headerTitle.value }}
        </span>
      </div>
    </div>
    <div class="corporation_usage">
      <div class="corporation_usage_background">
        <div class="corporation_usage_left_side">
          <div class="detail_content">
            <div class="total_period_label assessment_title_label">
              {{ tenantNameTitle }}
            </div>
            <div class="tenant_name">
              {{ tenantNameValue }}
            </div>
          </div>
          <div class="detail_content">
            <div class="total_period_label assessment_title_label">
              {{ targetMonthTitle }}
            </div>

            <div class="datepicker_section">
              <datepicker
                :placeholder="placeholderValue"
                :config="config"
                id="targetMonth"
                @on-change="customFormatter"
                :locale="ja"
                :value="value"
                class="start_datepicker"
              >
              </datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="corporation_bottom">
        <div class="corporation_bottom_buttons">
          <input
            type="button"
            :value="exportButton"
            class="finish_button"
            @click="showExportModal = true"
          />
        </div>
      </div>
      <div class="complete_modal_window" v-if="showFailureAuditLogModal">
        <completeModalWindow
          :question="failureWordAuditLog"
          @close="closeFailureAuditLogModal"
        >
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureCallHistoryModal">
        <completeModalWindow
          :question="failureWordCallHistory"
          @close="closeFailureCallHistoryModal"
        >
        </completeModalWindow>
      </div>
      <div class="export_modal_window" v-if="showExportModal">
        <exportModalWindow @close="close" @export="exportLog">
        </exportModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import exportModalWindow from '../modalWindow/exportModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'
import datepicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import japanese from 'flatpickr/dist/l10n/ja.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'

export default {
  data() {
    return {
      exportButton: 'エクスポート',
      tenantNameTitle: 'テナント名',
      targetMonthTitle: '対象月',
      targetMonth: '',
      failureWordAuditLog: '',
      failureWordCallHistory: '',
      showFailureAuditLogModal: false,
      showFailureCallHistoryModal: false,
      showloadingModal: false,
      showExportModal: false,
      ja: japanese,
      config: {
        dateformat: 'YYYY/mm/DD',
        locale: 'ja',
        minDate: '2020-01',
        maxDate: 'today',
        plugins: [
          monthSelectPlugin({
            dateFormat: 'Y年 m月'
          })
        ]
      },
      value: '',
      placeholderValue: 'Select Month',
      cancelFlag: false
    }
  },
  computed: {
    headerTitles() {
      return this.$store.state.masters.detailHeaderTitle
    },
    tenantNameValue() {
      return this.$store.state.corporations.corporation.companyName
    },
    corporationNameValue() {
      return this.$store.state.corporations.corporation.corporationName
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    nowDateTime() {
      var dt = new Date()
      var y = dt.getFullYear()
      var m = ('00' + (dt.getMonth() + 1)).slice(-2)
      var d = ('00' + dt.getDate()).slice(-2)
      return y + m + d
    }
  },
  async created() {},
  components: {
    completeModalWindow,
    exportModalWindow,
    loadingModalWindow,
    datepicker
  },
  methods: {
    pageLink(path) {
      this.$router.push(path)
    },
    close(e) {
      this.showFailureAuditLogModal = false
      this.showFailureCallHistoryModal = false
      this.showExportModal = false
      this.showloadingModal = false
    },
    async closeFailureAuditLogModal(e) {
      this.showFailureAuditLogModal = false
      if (!this.cancelFlag) {
        this.showloadingModal = true
        await this.exportLogCallHistory()
      }
    },
    closeFailureCallHistoryModal(e) {
      this.showFailureCallHistoryModal = false
      this.showloadingModal = false
    },
    customFormatter(e) {
      let date = new Date(e)
      this.targetMonth = date.getTime()
    },
    async exportLog(e) {
      this.showloadingModal = true
      this.showExportModal = false
      this.cancelFlag = false
      try {
        if (!this.targetMonth) {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_700001
          let eventType = 9
          let reason = 'MSGCRD0128 '
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.failureWordAuditLog =
            this.sysErrorMsg.MSGCRD0128.name +
            this.sysErrorMsg.MSGCRD0128.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFailureAuditLogModal = true
          this.showloadingModal = false
          this.cancelFlag = true
          return
        }
        await this.exportLogAuditLog()
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_700001
        let eventType = 9
        let reason = 'MSGCRD0127'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWordAuditLog =
          this.sysErrorMsg.MSGCRD0127.name +
          this.sysErrorMsg.MSGCRD0127.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureAuditLogModal = true
      }
      this.showloadingModal = false
    },
    async exportLogAuditLog() {
      try {
        await this.$store.dispatch('corporations/setUsageLogs', {
          type: 0,
          targetMonth: this.targetMonth,
          tenantKey: this.$store.state.corporations.corporation.tenantKey
        })
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_700001
        let eventType = 3
        let reason = 'MSGCRD0124 '
        if (error.response) {
          this.failureWordAuditLog =
            this.sysErrorMsg.MSGCRD0124.name +
            this.sysErrorMsg.MSGCRD0124.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRD0001'
          eventType = 9
          this.failureWordAuditLog =
            this.sysErrorMsg.MSGCRD0001.name +
            this.sysErrorMsg.MSGCRD0001.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureAuditLogModal = true
        this.showloadingModal = false
        return
      }

      // APIからレスポンスが返ってきた後の処理
      let result = ''
      let logs = this.$store.state.corporations.usageLogsAuditLog
      if (logs[0].values.length === 0) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_700001
        let eventType = 9
        let reason = 'MSGCRD0125'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWordAuditLog =
          this.sysErrorMsg.MSGCRD0125.name +
          'AuditLog' +
          this.sysErrorMsg.MSGCRD0125.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureAuditLogModal = true
        this.showloadingModal = false
        return
      }
      for (let i = 0; i < logs[0].title.length; i++) {
        result += this.exportSetDoubleQuotation(logs[0].title[i])
        if (i === logs[0].title.length - 1) {
          result += '\n'
        } else {
          result += ','
        }
      }
      for (let i = 0; i < logs[0].values.length; i++) {
        for (let j = 0; j < logs[0].values[i].length; j++) {
          result += this.exportSetDoubleQuotation(logs[0].values[i][j])
          if (j === logs[0].values[i].length - 1) {
            result += '\n'
          } else {
            result += ','
          }
        }
      }
      const date = new Date(this.targetMonth)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      let csv = ''
      csv += result
      let link = document.createElement('a')
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let blob
      if (window.navigator.msSaveOrOpenBlob) {
        // for ie
        blob = new Blob([bom, csv], {type: 'text/csv'})
        window.navigator.msSaveOrOpenBlob(
          blob,
          '使用量ログ(' +
            this.corporationNameValue +
            ')_auditlog_' +
            year +
            month +
            '.csv'
        )
      } else if (window.webkitURL && window.webkitURL.createObjectURL) {
        // for chrome (and safari)
        blob = new Blob([bom, csv], {type: 'text/csv'})
        link.setAttribute(
          'download',
          '使用量ログ(' +
            this.corporationNameValue +
            ')_auditlog_' +
            year +
            month +
            '.csv'
        )
        link.setAttribute('href', window.webkitURL.createObjectURL(blob))
        link.click()
      } else if (window.URL && window.URL.createObjectURL) {
        // for firefox
        blob = new Blob([bom, csv], {type: 'text/csv'})
        link.setAttribute(
          'download',
          '使用量ログ(' +
            this.corporationNameValue +
            ')_auditlog_' +
            year +
            month +
            '.csv'
        )
        link.setAttribute('href', window.URL.createObjectURL(blob))
        link.click()
      } else {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_700001
        let eventType = 9
        let reason = 'MSGCRD0126'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWordAuditLog =
          this.sysErrorMsg.MSGCRD0126.name +
          this.sysErrorMsg.MSGCRD0126.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureAuditLogModal = true
        this.showloadingModal = false
        return
      }
      window.URL.revokeObjectURL(link)
      await this.exportLogCallHistory()
    },
    async exportLogCallHistory(targetMonthDateTime) {
      try {
        await this.$store.dispatch('corporations/setUsageLogs', {
          type: 1,
          targetMonth: this.targetMonth,
          tenantKey: this.$store.state.corporations.corporation.tenantKey
        })
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_700001
        let eventType = 3
        let reason = 'MSGCRD0124 '
        if (error.response) {
          this.failureWordCallHistory =
            this.sysErrorMsg.MSGCRD0124.name +
            this.sysErrorMsg.MSGCRD0124.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRD0001'
          eventType = 9
          this.failureWordCallHistory =
            this.sysErrorMsg.MSGCRD0001.name +
            this.sysErrorMsg.MSGCRD0001.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureCallHistoryModal = true
        this.showloadingModal = false
        return
      }

      // APIからレスポンスが返ってきた後の処理
      let result = ''
      let logs = this.$store.state.corporations.usageLogsCallHistory
      if (logs[0].values.length === 0) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_700001
        let eventType = 9
        let reason = 'MSGCRD0125'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWordCallHistory =
          this.sysErrorMsg.MSGCRD0125.name +
          'CallHistory' +
          this.sysErrorMsg.MSGCRD0125.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureCallHistoryModal = true
        this.showloadingModal = false
        return
      }
      for (let i = 0; i < logs[0].title.length; i++) {
        result += this.exportSetDoubleQuotation(logs[0].title[i])
        if (i === logs[0].title.length - 1) {
          result += '\n'
        } else {
          result += ','
        }
      }
      for (let i = 0; i < logs[0].values.length; i++) {
        for (let j = 0; j < logs[0].values[i].length; j++) {
          result += this.exportSetDoubleQuotation(logs[0].values[i][j])
          if (j === logs[0].values[i].length - 1) {
            result += '\n'
          } else {
            result += ','
          }
        }
      }
      const date = new Date(this.targetMonth)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      let csv = ''
      csv += result
      let link = document.createElement('a')
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let blob
      if (window.navigator.msSaveOrOpenBlob) {
        // for ie
        blob = new Blob([bom, csv], {type: 'text/csv'})
        window.navigator.msSaveOrOpenBlob(
          blob,
          '使用量ログ(' +
            this.corporationNameValue +
            ')_callhistory_' +
            year +
            month +
            '.csv'
        )
      } else if (window.webkitURL && window.webkitURL.createObjectURL) {
        // for chrome (and safari)
        blob = new Blob([bom, csv], {type: 'text/csv'})
        link.setAttribute(
          'download',
          '使用量ログ(' +
            this.corporationNameValue +
            ')_callhistory_' +
            year +
            month +
            '.csv'
        )
        link.setAttribute('href', window.webkitURL.createObjectURL(blob))
        link.click()
      } else if (window.URL && window.URL.createObjectURL) {
        // for firefox
        blob = new Blob([bom, csv], {type: 'text/csv'})
        link.setAttribute(
          'download',
          '使用量ログ(' +
            this.corporationNameValue +
            ')_callhistory_' +
            year +
            month +
            '.csv'
        )
        link.setAttribute('href', window.URL.createObjectURL(blob))
        link.click()
      } else {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_700001
        let eventType = 9
        let reason = 'MSGCRD0126'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWordCallHistory =
          this.sysErrorMsg.MSGCRD0126.name +
          this.sysErrorMsg.MSGCRD0126.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureCallHistoryModal = true
      }
      this.showloadingModal = false
      window.URL.revokeObjectURL(link)
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    }
  }
}
</script>

<style scoped>
.datepicker_section {
  width: 100%;
  padding-bottom: 15px;
  padding-left: 5%;
}
.start_datepicker {
  width: 50%;
}
.detail_label {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationUsageExport.vue